/* eslint-disable react-hooks/exhaustive-deps */
// ImageUpload.js

// import React, { useEffect, useRef, useState } from "react";

// const ImageUpload = ({
//   defaultImage,
//   onChange,
//   className,
//   DataFrom,
//   style,
//   PlexiImageTrigger,
//   CropEnable,
//   resetzoom,
// }) => {
//   const [imagePreview, setImagePreview] = useState(defaultImage);
//   const [isImageSelected, setisImageSelected] = useState(false);
//   const fileInputRef = useRef(null);
//   const prevPlexiImageTrigger = useRef(PlexiImageTrigger);
//   const [EnableCrop, setEnableCrop] = useState(false);

//   const [scale, setScale] = useState(1);
//   const [position, setPosition] = useState({ x: 0, y: 0 });
//   const [isDragging, setIsDragging] = useState(false);
//   const [dragStart, setDragStart] = useState({ x: 0, y: 0 });
//   const containerRef = useRef(null);

//   useEffect(() => {
//     console.log(PlexiImageTrigger, prevPlexiImageTrigger);
//     if (
//       PlexiImageTrigger !== prevPlexiImageTrigger.current &&
//       DataFrom === "Plexi"
//     ) {
//       handleImageClick();
//     }
//     prevPlexiImageTrigger.current = PlexiImageTrigger;
//   }, [PlexiImageTrigger, DataFrom]);

//   useEffect(() => {
//     setEnableCrop(CropEnable);
//   }, [CropEnable]);

//   useEffect(() => {
//     if (resetzoom === true) {
//       setPosition({ x: 0, y: 0 });
//       setScale(1);
//     }
//   }, [resetzoom]);

//   const handleImageClick = () => {
//     // Trigger the click event of the hidden file input
//     fileInputRef.current.click();
//   };

//   const handleImageChange = (event) => {
//     const file = event.target.files[0];
//     if (file) {
//       setimageloading(true);
//       setisImageSelected(true);
//       const reader = new FileReader();
//       reader.onloadend = () => {
//         setImagePreview(reader.result);
//         onChange && onChange(file);
//       };
//       reader.readAsDataURL(file);
//     }
//   };

//   useEffect(() => {
//     if (DataFrom === "Single_Canvas") {
//       if (!isImageSelected) {
//         setImagePreview(defaultImage);
//       }
//     }
//   }, [defaultImage]);

//   const [imageloading, setimageloading] = useState(false);

//   const handleImageLoad = () => {
//     setimageloading(false);
//   };

//   const handleScroll = (e) => {
//     if (!EnableCrop || !containerRef.current.contains(e.target)) {
//       return;
//     }

//     e.preventDefault();
//     setScale((prevScale) => {
//       const newScale =
//         e.deltaY > 0 ? Math.max(prevScale - 0.1, 1) : prevScale + 0.1;

//       setPosition((prevPosition) => {
//         const container = containerRef.current;
//         const containerRect = container.getBoundingClientRect();
//         const imageWidth = containerRect.width * newScale;
//         const imageHeight = containerRect.height * newScale;

//         const maxOffsetX = Math.max((imageWidth - containerRect.width) / 2, 0);
//         const maxOffsetY = Math.max(
//           (imageHeight - containerRect.height) / 2,
//           0
//         );

//         const boundedX = Math.max(
//           -maxOffsetX,
//           Math.min(prevPosition.x, maxOffsetX)
//         );
//         const boundedY = Math.max(
//           -maxOffsetY,
//           Math.min(prevPosition.y, maxOffsetY)
//         );

//         return { x: boundedX, y: boundedY };
//       });

//       return newScale;
//     });
//   };

//   useEffect(() => {
//     window.addEventListener("wheel", handleScroll, { passive: false });
//     return () => {
//       window.removeEventListener("wheel", handleScroll);
//     };
//   }, [EnableCrop]);

//   const handleMouseDown = (e) => {
//     if (!EnableCrop) return;
//     e.preventDefault();
//     setIsDragging(true);
//     setDragStart({ x: e.clientX - position.x, y: e.clientY - position.y });
//   };

//   const handleMouseMove = (e) => {
//     if (!EnableCrop || !isDragging) return;

//     const container = containerRef.current;
//     const containerRect = container.getBoundingClientRect();
//     const imageWidth = containerRect.width * scale;
//     const imageHeight = containerRect.height * scale;

//     const newX = e.clientX - dragStart.x;
//     const newY = e.clientY - dragStart.y;

//     const maxOffsetX = Math.max((imageWidth - containerRect.width) / 2, 0);
//     const maxOffsetY = Math.max((imageHeight - containerRect.height) / 2, 0);

//     const boundedX = Math.max(-maxOffsetX, Math.min(newX, maxOffsetX));
//     const boundedY = Math.max(-maxOffsetY, Math.min(newY, maxOffsetY));

//     setPosition({ x: boundedX, y: boundedY });
//   };

//   const handleMouseUp = () => {
//     if (!EnableCrop) return;
//     setIsDragging(false);
//   };

//   const handleDragStart = (e) => {
//     e.preventDefault(); // Prevent default drag behavior
//   };

//   return (
//     <div className="control-group file-upload">
//       <div className="image-box">
//         {imageloading && (
//           <div
//             className={`align-items-center d-flex justify-content-center ${className}`}
//           >
//             <i
//               className="fa fa-spinner fa-pulse fa-2x fa-fw"
//               style={{ animationDuration: "1.5s" }}
//             ></i>
//           </div>
//         )}

//         <div
//           className="image-div"
//           onMouseDown={handleMouseDown}
//           onMouseMove={handleMouseMove}
//           onMouseUp={handleMouseUp}
//           onMouseLeave={handleMouseUp}
//           style={{
//             overflow: "hidden",
//             position: "relative",
//             cursor: EnableCrop ? (isDragging ? "grabbing" : "grab") : "",
//           }}
//         >
//           <img
//             src={imagePreview || defaultImage}
//             alt=""
//             onClick={!EnableCrop && !isDragging ? handleImageClick : null}
//             onDragStart={handleDragStart}
//             className={`${imageloading ? "d-none" : "d-block"} ${className}`}
//             style={{
//               ...style,
//               transform: `translate(${position.x}px, ${position.y}px) scale(${scale})`,
//               transformOrigin: "center center",
//               objectFit: "fill",
//             }}
//             onLoad={handleImageLoad}
//             ref={containerRef}
//           />
//         </div>
//       </div>

//       <div className="controls" style={{ display: "none" }}>
//         <input
//           type="file"
//           onChange={handleImageChange}
//           ref={fileInputRef}
//           style={{ display: "none" }}
//         />
//       </div>
//     </div>
//   );
// };

// export default ImageUpload;

import React, { useEffect, useRef, useState } from "react";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import { toastEmmit } from "../../../Helper/Toastr";

const ImageUpload = ({
  defaultImage,
  onChange,
  className,
  DataFrom,
  style,
  PlexiImageTrigger,
  CropEnable,
  resetzoom,
}) => {
  const [imagePreview, setImagePreview] = useState(defaultImage);
  const [isImageSelected, setisImageSelected] = useState(false);
  const fileInputRef = useRef(null);
  const prevPlexiImageTrigger = useRef(PlexiImageTrigger);
  const [EnableCrop, setEnableCrop] = useState(false);
  const transformRef = useRef(null);

  useEffect(() => {
    if (
      PlexiImageTrigger !== prevPlexiImageTrigger.current &&
      DataFrom === "Plexi"
    ) {
      handleImageClick();
    }
    prevPlexiImageTrigger.current = PlexiImageTrigger;
  }, [PlexiImageTrigger, DataFrom]);

  useEffect(() => {
    setEnableCrop(CropEnable);
  }, [CropEnable]);

  useEffect(() => {
    if (resetzoom && transformRef.current) {
      transformRef.current.resetTransform();
    }
  }, [resetzoom]);

  const handleImageClick = () => {
    if (!EnableCrop) {
      fileInputRef.current.click();
    }
  };

  const handleImageChange = (event) => {
    const file = event.target.files[0]; 
    if (file) {
      const validImageTypes = ["image/jpeg", "image/png", "image/jpg", "image/svg+xml"];
      if (!validImageTypes.includes(file.type)) {
        toastEmmit("error","Please upload a valid image");
        return;
      }

      setimageloading(true);
      setisImageSelected(true);
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
        onChange && onChange(file);
      };
      reader.readAsDataURL(file);
    }
  };

  useEffect(() => {
    if (DataFrom === "Single_Canvas") {
      if (!isImageSelected) {
        setImagePreview(defaultImage);
      }
    }
  }, [defaultImage]);

  const [imageloading, setimageloading] = useState(false);

  const handleImageLoad = () => {
    setimageloading(false);
  };

  const handleDragStart = (e) => {
    e.preventDefault(); // Prevent default drag behavior
  };

  return (
    <div className="control-group file-upload">
      <div className="image-box">
        {imageloading && (
          <div
            className={`align-items-center d-flex justify-content-center ${className}`}
          >
            <i
              className="fa fa-spinner fa-pulse fa-2x fa-fw"
              style={{ animationDuration: "1.5s" }}
            ></i>
          </div>
        )}
        <div
          style={{
            overflow: "hidden",
            position: "relative",
            cursor: EnableCrop ? "grab" : "pointer",
          }}
          onClick={handleImageClick}
          className="imageDiv"
        >
          <TransformWrapper
            wheel={{ disabled: !EnableCrop }}
            pan={{ disabled: !EnableCrop }}
            doubleClick={{ disabled: true }}
            panning={{ disabled: !EnableCrop }}
            ref={transformRef}
          >
            <TransformComponent>
              <img
                src={imagePreview || defaultImage}
                alt=""
                className={`${
                  imageloading ? "d-none" : "d-block"
                } ${className}`}
                style={style}
                onDragStart={handleDragStart}
                onLoad={handleImageLoad}
              />
            </TransformComponent>
          </TransformWrapper>
        </div>
      </div>
      <div className="controls" style={{ display: "none" }}>
        <input
          type="file"
        accept="image/jpeg, image/png,image/jpg,image/svg+xml"
          onChange={handleImageChange}
          ref={fileInputRef}
          style={{ display: "none" }}
        />
      </div>
    </div>
  );
};

export default ImageUpload;
